import { Controller } from "@hotwired/stimulus";

const TYPE_DELAY = 68;
const DELETE_DELAY = 34;
const WORD_PAUSE = 980;
const MARK_DURATION = 560;
const MARK_PAUSE = 1050;

export default class extends Controller {
  static targets = ["word"];
  static values = {
    words: Array,
  };

  connect() {
    this.words = this.hasWordsValue ? this.wordsValue : [];
    this.wordIndex = 0;
    this.characterIndex = 0;
    this.timeout = null;
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    if (this.reducedMotion || this.words.length === 0) {
      this.showFallbackWord();
      return;
    }

    this.wordTarget.textContent = "";
    this.queue(() => this.typeWord(), 260);
  }

  disconnect() {
    clearTimeout(this.timeout);
  }

  typeWord() {
    const word = this.currentDisplayWord;

    if (this.characterIndex < word.length) {
      this.characterIndex += 1;
      this.wordTarget.textContent = word.slice(0, this.characterIndex);
      this.queue(() => this.typeWord(), TYPE_DELAY + Math.random() * 28);
      return;
    }

    if (this.currentWord === "enjoy") {
      this.element.classList.add("is-marked");
      this.queue(() => this.deleteWord(), MARK_DURATION + MARK_PAUSE);
      return;
    }

    this.queue(() => this.deleteWord(), WORD_PAUSE);
  }

  deleteWord() {
    this.element.classList.remove("is-marked");

    if (this.characterIndex > 0) {
      this.characterIndex -= 1;
      this.wordTarget.textContent = this.currentDisplayWord.slice(0, this.characterIndex);
      this.queue(() => this.deleteWord(), DELETE_DELAY);
      return;
    }

    this.wordIndex = (this.wordIndex + 1) % this.words.length;
    this.queue(() => this.typeWord(), 170);
  }

  showFallbackWord() {
    this.wordTarget.textContent = "run.";
  }

  get currentWord() {
    return this.words[this.wordIndex];
  }

  get currentDisplayWord() {
    return `${this.currentWord}.`;
  }

  queue(callback, delay) {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(callback, delay);
  }
}
